<mat-toolbar class="header-toolbar {{ displayClass }}"
  [attr.data-aue-resource]="aueResource"
  data-aue-type="component"
  data-aue-model="lpmi/components/common/header"
  data-aue-label="Header">
  <div class="left-content-wrapper">
    <nuc-menu (menuAction)="handleMenuAction($event)" [isExpandMoreOpen]="isExpandMoreOpen" [pageContent]="pageContent"
      [menuAppLinks]="appLinks"></nuc-menu>
    <nuc-icon displayClass="header-logo" [iconSrc]="this.headerData?.labelIcon" size="40" class="logoImg"
      data-aue-prop="labelIcon" data-aue-type="media"
      (click)="redirectToLanding()"></nuc-icon>
  </div>

  <div class="logo-image-conatiner">
    <nuc-icon displayClass="header-logo" [iconSrc]="displayClass == 'blueTheme'? logoWhite : logoBlue" size="40"
      class="logoImg"
      [attr.data-aue-prop]="displayClass == 'blueTheme' ? 'desktopWhiteLogo' : 'desktopBlueLogo'"
      data-aue-type="media"
      (click)="redirectToLanding()"></nuc-icon>
  </div>

  <div class="right-content-wrapper">
    <nuc-icon *ngIf="this.headerData?.showSearchIcon" iconClass="search" size="{{ size }} material-icons-outlined"
      class="search-icon {{ displayClass }}" (click)="onClick()"></nuc-icon>
    <nuc-notifications-menu displayClass="{{ displayClass }}" size="{{ size }}" [pageContent]="pageContent"
      [showNotificationIcon]="this.headerData?.showNotificationIcon" [notificationsMobileMenu]="notificationsMobileMenu"
      [desktopOverlayState]="desktopOverlayState"
      data-aue-prop="showNotificationIcon" data-aue-type="boolean"></nuc-notifications-menu>
    <nuc-language-switcher displayClass="lp-lang-dropdown" [options]="langOptions" [formControl]="langValue"
      displayIconClass="lang-icon" iconClass="stla-language-new" size="{{ size }}" trackByKey="isoCode"
      (selectionChange)="onLanguageChange($event)" displayKey="languageCode"></nuc-language-switcher>
    <nuc-user-menu displayClass="{{ displayClass }}" size="{{ size }}" [pageContent]="pageContent"
      [userMenuMobileState]="userMenuMobileState" [desktopOverlayState]="desktopOverlayState"></nuc-user-menu>
  </div>

  <div class="mobile-lang">
    @if(userType === 'LeapMotor'){
     <nuc-language-switcher displayClass="lp-lang-dropdown" [options]="langOptions" [formControl]="langValue"
      displayIconClass="lang-icon" iconClass="stla-language-new" size="{{ size }}" trackByKey="isoCode"
      (selectionChange)="onLanguageChange($event)" displayKey="languageCode"></nuc-language-switcher>
    }
  </div>
  <div class="mobile-right-conent-wrapper">
    @if(!isExpandMoreOpen){
    <nuc-icon class="expandMore-icon" iconClass="more_vert" size="24 material-icons-outlined"
      (click)="openExpandMoreDialog()"></nuc-icon>
    } @else{
    <nuc-icon class="expandMore-close-icon" iconClass="close" size="24 material-icons-outlined"
      (click)="closeDialog()"></nuc-icon>
    }

    <div *ngIf="isExpandMoreOpen" class="backgroundBlurContainer">
      <div class="mobileMenuOptions {{ displayClass }}">
        <nuc-icon *ngIf="this.headerData?.showSearchIcon" iconClass="search" size="{{ size }} material-icons-outlined"
          class="search-icon mobile-search-icon" (click)="onClick()"></nuc-icon>
        <nuc-notifications-menu [showNotificationIcon]="this.headerData?.showNotificationIcon"
          displayClass="{{ displayClass }}" [pageContent]="pageContent"
          [notificationsMobileMenu]="notificationsMobileMenu"></nuc-notifications-menu>
        <nuc-user-menu displayClass="{{ displayClass }}" [pageContent]="pageContent"
          [userMenuMobileState]="userMenuMobileState"></nuc-user-menu>
      </div>
    </div>
  </div>
</mat-toolbar>